import React, { useContext, useEffect } from 'react'
import { useRefinementList, ToggleRefinement } from 'react-instantsearch-hooks-web';
import { useZipCodeStatus } from '../../hooks/app';
import appContext from '../../Context/appContext';
import { ASAP, SCHEDULE } from '../../constants/deliveryType';
import { GANJAGODDESS } from '../../constants/website';
import { useDispatch } from 'react-redux';
import { setSearchProductCount } from '../../redux/slices/searchSlice';

const isGG = process.env.NEXT_PUBLIC_APP == GANJAGODDESS;
const CustomRefinementListDisabled = ({ locationId }) => {
  const { refine } = useRefinementList({
    attribute: `location_specific_details.${locationId}.disabled`,
  })

  useEffect(() => {
    const firstRefine = async () => {
      if (refine) {
        refine(['0']);
      }
    };
    firstRefine();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{/* Your JSX */}</>;
}

const CustomRefinementListLocations = ({ locationId }) => {
  const { refine } = useRefinementList({
    attribute: `locations`,
  })

  useEffect(() => {
    const firstRefine = async () => {
      if (refine) {
        refine([locationId]);
      }
    };
    firstRefine();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{/* Your JSX */}</>;
}

const CustomRefinementListEnabled = () => {
  const { refine } = useRefinementList({
    attribute: `enabled_categories`,
  })

  useEffect(() => {
    const firstRefine = async () => {
      if (refine) {
        refine(['1']);
      }
    };
    firstRefine();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{/* Your JSX */}</>;
}

const CustomRefinementListListed = () => {
  const { refine } = useRefinementList({
    attribute: `is_unlisted`,
  })

  useEffect(() => {
    const firstRefine = async () => {
      if (refine) {
        refine(['0']);
      }
    };
    firstRefine();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{/* Your JSX */}</>;
}

const CustomRefinementListPreDeal = ({ locationId }) => {
  const { refine } = useRefinementList({
    attribute: `domain_location_specific_details.${locationId}.is_pre_deal_available`,
  })

  useEffect(() => {
    const firstRefine = async () => {
      if (refine) {
        refine(['0']);
      }
    };
    firstRefine();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{/* Your JSX */}</>;
}

const CustomRefinementListRadio = ({ selectedTab, zoneId, locationId }) => {
  const { items } = useRefinementList({
    attribute: `location_specific_details.${locationId}.delivery`,
    limit: 50
  })
  const asap = items?.find(item => item.label === String(zoneId)) || {};
  const schedule = items?.find(item => item.label === 'schedule') || {};

  // const {
  //   dispatch
  // } = useContext(appContext);
  const dispatchRedux = useDispatch()
  let asapCount = asap?.count || 0;
  let scheduleCount = schedule?.count || 0
  useEffect(() => {
    dispatchRedux(setSearchProductCount({ asapCount, scheduleCount }))
    // dispatch({ type: 'setSearchProductCount', payload: { asapCount, scheduleCount } });
    dispatchRedux(setSearchProductCount({ asapCount, scheduleCount }))
  }, [asapCount, scheduleCount])

  return <>{/* Your JSX */}</>;
};


const HiddenFilter = ({ currentTab }) => {
  const {
    data: { locationId, zoneId }
  } = useZipCodeStatus();

  const tabValue = currentTab == ASAP && !isGG ? zoneId : SCHEDULE

  return (
    <>
      {
        locationId && zoneId ?
          <>
            <CustomRefinementListRadio
              selectedTab={currentTab}
              locationId={locationId}
              zoneId={zoneId}
            />
            <ToggleRefinement className='d-none' attribute={`location_specific_details.${locationId}.delivery`}
              on={tabValue} off={tabValue} />
            <CustomRefinementListDisabled locationId={locationId} />
            <CustomRefinementListLocations locationId={locationId} />
            <CustomRefinementListEnabled />
            <CustomRefinementListListed />
            <CustomRefinementListPreDeal locationId={locationId} />
          </>
          : null
      }

    </>
  )
}

export default HiddenFilter